var _defs, _path, _path2, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: #263979;\n      }\n\n      .cls-1, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        font-size: 111.2px;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        font-family: AcuminConcept-Medium, 'Acumin Variable Concept';\n        font-variation-settings: 'wght' 500, 'wdth' 100, 'slnt' 0;\n        font-weight: 500;\n      }\n\n      .cls-3 {\n        font-size: 242.65px;\n      }\n\n      .cls-4 {\n        font-size: 127.9px;\n      }\n\n      .cls-5 {\n        fill: #fcb701;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M452.58,72.55L36.02,103.66c-6.89.53-9.87,5.99-9.87,11l-.56,220.57c0,5.01,3.54,7.02,10.43,7.01l58.77-.22-4.07,83.79,85.5-84.1,276.35-1.05c10.6.47,26.71-1.18,26.71-6.9V83.22c0-5.72-16.11-11.97-26.71-10.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M481.89,64.8c-4.37-3.87-12.08-5.56-20.63-4.53L30.96,92.5c-9.25.71-16.5,7-16.5,14.3v22.94c2.59.1,5.18.19,7.76.25v-23.2c0-2.76,3.83-6.14,9.33-6.56l430.38-32.24.18-.02c7.08-.87,12.44.7,14.63,2.63,1.03.91,1.03,1.61,1.03,1.84v259.67c0,.68-.39,1.4-1.17,2.15-2.25,2.15-7.68,4.19-14.79,3.87h-.09s-285.61,1.09-285.61,1.09h-1.58s-82.38,81.3-82.38,81.3l3.92-80.99-64.81.25c-3.07-.03-5.96-1.02-7.69-2.74-.61-.61-1.34-1.59-1.34-2.8v-194.54c-2.59-.07-5.18-.15-7.76-.25v194.79c0,3.02,1.29,5.96,3.62,8.29,3.19,3.18,7.98,5,13.16,5h.04l56.63-.22-4.49,92.71,94.3-93.05,283.85-1.09c8.49.36,16.1-1.89,20.41-6.02,2.33-2.23,3.57-4.92,3.57-7.76V72.45c0-2.89-1.26-5.54-3.65-7.65Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(186.84 299.72)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(367.09 282.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(78.3 206.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq-icon.8a62ff87fd41471247cf1307310b8e6d.svg";
export { ForwardRef as ReactComponent };